export default __webpack_public_path__ + "static/media/twitter.8d9ae8c8.png";